import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export default React.memo(props => (
  <SvgIcon {...props} width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.99998 6.33337C7.0795 6.33337 6.33331 7.07957 6.33331 8.00004C6.33331 8.92052 7.0795 9.66671 7.99998 9.66671C8.92045 9.66671 9.66665 8.92052 9.66665 8.00004C9.66665 7.07957 8.92045 6.33337 7.99998 6.33337ZM5.33331 8.00004C5.33331 6.52728 6.52722 5.33337 7.99998 5.33337C9.47274 5.33337 10.6666 6.52728 10.6666 8.00004C10.6666 9.4728 9.47274 10.6667 7.99998 10.6667C6.52722 10.6667 5.33331 9.4728 5.33331 8.00004Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.99998 1.33337C8.27612 1.33337 8.49998 1.55723 8.49998 1.83337V2.83337C8.49998 3.10952 8.27612 3.33337 7.99998 3.33337C7.72384 3.33337 7.49998 3.10952 7.49998 2.83337V1.83337C7.49998 1.55723 7.72384 1.33337 7.99998 1.33337Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.8535 4.14648C12.0488 4.34174 12.0488 4.65832 11.8535 4.85358L11.0641 5.64302C10.8689 5.83829 10.5523 5.8383 10.357 5.64304C10.1618 5.44779 10.1618 5.1312 10.357 4.93594L11.1464 4.1465C11.3417 3.95123 11.6583 3.95122 11.8535 4.14648Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.6666 8.00011C12.6666 7.72396 12.8905 7.50011 13.1666 7.50011H14.1666C14.4428 7.50011 14.6666 7.72396 14.6666 8.00011C14.6666 8.27625 14.4428 8.50011 14.1666 8.50011H13.1666C12.8905 8.50011 12.6666 8.27625 12.6666 8.00011Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.357 10.3572C10.5523 10.1619 10.8689 10.1619 11.0641 10.3572L11.8535 11.1466C12.0488 11.3418 12.0488 11.6584 11.8535 11.8537C11.6583 12.0489 11.3417 12.0489 11.1464 11.8537L10.357 11.0643C10.1618 10.869 10.1618 10.5524 10.357 10.3572Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.99998 12.6667C8.27612 12.6667 8.49998 12.8906 8.49998 13.1667V14.1667C8.49998 14.4428 8.27612 14.6667 7.99998 14.6667C7.72384 14.6667 7.49998 14.4428 7.49998 14.1667V13.1667C7.49998 12.8906 7.72384 12.6667 7.99998 12.6667Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.64294 10.3571C5.8382 10.5524 5.83819 10.8689 5.64293 11.0642L4.8535 11.8536C4.65823 12.0489 4.34165 12.0489 4.14639 11.8536C3.95113 11.6583 3.95114 11.3417 4.14641 11.1465L4.93583 10.3571C5.1311 10.1618 5.44768 10.1618 5.64294 10.3571Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.33331 8.00011C1.33331 7.72396 1.55717 7.50011 1.83331 7.50011H2.83331C3.10946 7.50011 3.33331 7.72396 3.33331 8.00011C3.33331 8.27625 3.10946 8.50011 2.83331 8.50011H1.83331C1.55717 8.50011 1.33331 8.27625 1.33331 8.00011Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.14637 4.1465C4.34164 3.95124 4.65822 3.95125 4.85348 4.14652L5.64291 4.93598C5.83817 5.13125 5.83816 5.44783 5.64289 5.64309C5.44762 5.83835 5.13104 5.83834 4.93578 5.64307L4.14636 4.85361C3.9511 4.65834 3.95111 4.34176 4.14637 4.1465Z"
      fill="currentColor"
    />
  </SvgIcon>
));
